/* ─────────────────────────────────────────────────────────────
   PRICING TIERS — Single source of truth for all pricing data.
   The Homepage pricing section and the For Clubs page both
   import from here. Only update pricing in this one file.
   ───────────────────────────────────────────────────────────── */

export const pricingTiers = [
  {
    id: 'free',
    name: 'Free',
    price: '$0',
    period: 'forever',
    description: 'Perfect for casual players who want to track their rating.',
    features: [
      'ELO rating tracking',
      'Match logging',
      '1 group',
      'Basic stats',
    ],
    cta: 'Get started free',
    ctaHref: '/signup',
    highlight: false,
  },
  {
    id: 'pro',
    name: 'Pro',
    price: '$5',
    period: 'month',
    description: 'For serious players who want the full picture.',
    features: [
      'Everything in Free',
      'Advanced stats',
      'Multiple groups',
      'Match scheduling',
      'Rating history charts',
    ],
    cta: 'Start Pro',
    ctaHref: '/signup',
    highlight: true,
  },
  {
    id: 'club',
    name: 'Club',
    price: '$49',
    period: 'month',
    description: 'For clubs and offices with active communities.',
    features: [
      'Everything in Pro',
      'Admin dashboard',
      'Public leaderboard',
      'Tournament tools',
      'Up to 100 members',
      'Priority support',
    ],
    cta: 'Set up your club',
    ctaHref: '/signup',
    highlight: false,
  },
];

// The Club tier pulled out separately — used on the For Clubs page.
export const clubTier = pricingTiers.find(t => t.id === 'club');
